import { CreateReportButton } from "@/components/CreateReportButton";
import IntranetResources from "@/components/intranet/IntranetResources";

export default function Documents() {
  return <div className="max-w-7xl mx-auto" data-testid="documents-page"><div className="flex justify-end mb-2"><CreateReportButton module="documents"/></div><IntranetResources/></div>;
}
